import {StudentService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        students: [],
    },

    mutations: {
        saveStudents(current, teachers) {
            current.students.splice(0);
            current.students = teachers;
        }
    },

    actions: {
        async getStudentsWithFilterAction({commit}, filter) {
            await bindLoading(commit,
                async () => commit('saveStudents', await StudentService.getStudentsWithFilter(filter)), 'student');
        }
    }
}